import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar'
import Typography from '@mui/material/Typography'
import { SyntheticEvent } from 'react'
import { useShallow } from 'zustand/shallow'
import { useToasterStore } from './useToasterStore'

const anchorOrigin: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
}

export const ToasterUI = () => {
  const [hideToast, toasts] = useToasterStore(
    useShallow(({ hideToast, toasts }) => [hideToast, toasts]),
  )

  const handleClose = (_event?: SyntheticEvent | Event, reason?: string) => {
    reason !== 'clickaway' && hideToast()
  }

  const [activeToast] = toasts

  return (
    <Snackbar
      anchorOrigin={anchorOrigin}
      open={Boolean(activeToast)}
      onClose={handleClose}
      autoHideDuration={activeToast ? activeToast.autoHideDuration : undefined}>
      {activeToast && (
        <Alert
          onClose={handleClose}
          severity={activeToast.severity}
          sx={{
            alignItems: 'center !important',
            '& .MuiAlert-action': { pt: 0 },
          }}
          action={
            activeToast.action ? (
              <Button
                id="btnToastAction"
                color="inherit"
                size="small"
                onClick={() => {
                  activeToast.action?.onClick()
                  hideToast()
                }}>
                {activeToast.action.label}
              </Button>
            ) : undefined
          }>
          <Typography variant="body1" color="inherit">
            {activeToast.message}
          </Typography>
        </Alert>
      )}
    </Snackbar>
  )
}

export default ToasterUI
